<template>
  <div>
    <div class="flex md:justify-start justify-center">
      <div>
        <a :href="url">
          <input type="button" class="returnButton" id="button_return" :value="value" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  name: 'RedirectButtonComponent',
  props: {
    url: {
      type: String,
      default: 'http://172.16.201.7/principal.asp'
    },
    value: {
      type: String,
      default: 'Regresar'
    },
  }
}
</script>